import type { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';

import RootProviders from '@app/components/RootProviders';
import globalStore from '@app/store';

import TwigPropsContextProvider from './components/TwigPropsContextProvider';

type AppProvidersProps<TTwigContext> = {
    twigContext?: TTwigContext;
    isDarkmode?: boolean;
    store?: typeof globalStore;
};

declare global {
    interface Window {
        darkmode?: boolean;
    }
}

const AppProviders = <TTwigContext extends object = object>({
    children,
    twigContext,
    store = globalStore,
    isDarkmode = window.darkmode ?? false,
}: PropsWithChildren<AppProvidersProps<TTwigContext>>) => {
    let providers = (
        <Provider store={store}>
            <RootProviders isDarkmode={isDarkmode}>{children}</RootProviders>
        </Provider>
    );

    if (twigContext !== undefined) {
        providers = <TwigPropsContextProvider twigContext={twigContext}>{providers}</TwigPropsContextProvider>;
    }

    return providers;
};

export default AppProviders;
